import _ from "lodash";
import React, { useEffect, useState } from "react";
import { GoogleLogin } from "react-google-login";
import { connect } from "react-redux";
import { Button, Spinner } from "react-bootstrap";

import Api from "src/data/api";
import styles from "src/components/settings/settings.module.scss";
import { useShopifyAppBridge } from "src/components/shopify/appBridge";
import RetailerSettings from "../RetailerSettings";
import { ADDRESS_INITIAL_VALUES } from "../RetailerSettings/RetailerSettingsConstants";
import RetailerWidgetSettings from "../RetailerWidgetSettings";

function Settings({ settings, user, setRefetch }) {
    const { getAppBridge } = useShopifyAppBridge();
    const isShopify = getAppBridge() !== null;
    const [token, setToken] = useState(null);
    const { retailerZoomUuid, retailerPipedriveUuid } = settings;

    const zoomAppInstallUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${CONFIG.zoom.clientId}&redirect_uri=${CONFIG.zoom.redirect_uri}&state=${retailerZoomUuid}`;
    const pipedriveAppInstallUrl = `https://oauth.pipedrive.com/oauth/authorize?client_id=${CONFIG.pipedrive.clientId}&redirect_uri=${CONFIG.pipedrive.redirect_uri}&state=${retailerPipedriveUuid}`
    useEffect(() => {
        Api.getAuthToken().then((authToken) => setToken(authToken));
    }, []);

    const retailerSettings = {
        name: settings.name,
        websiteUrl: settings.url,
        email: settings.email,
        additionalEmails: settings.additionalEmails,
        timezone: settings.timezone,
        address: settings.retailerLocations[0] || ADDRESS_INITIAL_VALUES,
        additionalAddresses: settings.retailerLocations.slice(1),
        isRetailerOnlineOnly: settings.isRetailerOnlineOnly,
        availableSubscriptions: settings.availableSubscriptions,
        appointmentInPersonOnly: settings.appointmentInPersonOnly,
        appointmentVirtualOnly: settings.appointmentVirtualOnly,
        retailerWidgetImage: settings.retailer_widget_image,
        retailerWidgetImageName: settings.retailer_widget_image_name,
        virtualEmails: settings.virtualEmails,
        locationsEmails: settings.locationsEmails,
        fullLocations: settings.fullLocations,
        shouldHaveAllLocationsActive: settings.shouldHaveAllLocationsActive,
        createOrders: settings.create_orders,
        createDraftOrders: settings.create_draft_orders,
        locationsPhoneNumbers: settings.locationsPhoneNumbers,
        virtualPhoneNumbers: settings.virtualPhoneNumbers,
        locationsSelectedCalendars: settings.locationsSelectedCalendars,
        calendars: settings.userCalendars,
        virtualCalendars: settings.virtualSelectedCalendars,
        mappedCalendars: settings.mappedCalendars,
        mappedVirtualCalendars: settings.mappedVirtualCalendars,
        webappThemeColor: settings.webapp_theme_color,
        webappThemeTextColor: settings.webapp_theme_text_color,
        webappButtonColor: settings.webapp_button_color,
        webappButtonTextColor:settings.webapp_button_text_color,
        widgetTextContent: settings.widgetTextContent,
    };


    return (
        <div className={styles.settings}>
            <RetailerSettings
                widgetToken={settings.widget_token}
                isShopify={isShopify}
                settings={retailerSettings}
                widgetSettings={settings.widgetSettings}
                token={token}
                zoomAppInstallUrl={zoomAppInstallUrl}
                pipedriveAppInstallUrl={pipedriveAppInstallUrl}
                zoomAccountEmail={settings.zoomAccountEmail}
                setRefetch={setRefetch}
                user={user}
                flags={settings.flags}
            />
        </div>
    );
}

export default connect((store) => ({ user: store.user.data }))(Settings);
